module.exports = __webpack_public_path__ + "img/DSC_1142.90e50dcb.jpg";